import React, { useRef, useState, useEffect } from 'react';
import { uploadFile }from "../Services/Service";
import { CustomLoader } from "../Services/CommonLibrary"
import History from './History';

function FileUpload() {
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(''); // storing the uploaded file    
    // storing the recived file from backend
    const [data, getFile] = useState({ name: "", path: "" });
    const [alertInfo, setAlertInfo] = useState({
        xlsxErr : false,
        allfileErr : false,
        drnotesErr : false,
        cls : '',
        msg :''
      });
    const onShowAlert = (msg,xlvisible,allvisible,drnotevisible,clas)=>{
    setAlertInfo({...alertInfo, ['xlsxErr']: xlvisible,['allfileErr']:allvisible,['drnotesErr']:drnotevisible,['cls']:clas,['msg']: msg});
    }
    // const el = useRef(); // accesing input element
    const handleChange = (e) => {
        const MAX_FILE_SIZE = 2048;
        
        const file = e.target.files[0]; // accesing file
        const fileSizeKiloBytes = file.size / 1024;

        if(fileSizeKiloBytes > MAX_FILE_SIZE){
            // setErrorMsg("File size is less than minimum limit");
            // setIsSuccess(false)
            alert("File size should be less than 2 MB");
            document.getElementById(e.target.id).value = "";
            return
          }

        if(e.target.id == "xlsxFile"){
            document.getElementById("allFile").value = "";
            document.getElementById("doctornotes").value = "";
            setFile(file); // storing file
        }

        if(e.target.id == "allFile"){
            document.getElementById("xlsxFile").value = "";
            document.getElementById("doctornotes").value = "";
            setFile(file); // storing file
        }    
        
        if(e.target.id == "doctornotes"){
            document.getElementById("xlsxFile").value = "";
            document.getElementById("allFile").value = "";
            setFile(file); // storing file       
        }
        
        // console.log(file);  
    }
    const uploadFile_Html = async (e) => {
        
        
        if(file!=''){
            setLoading(true);
                const formData = new FormData();
                formData.append('file', file); // appending file
                formData.append('type', e.target.id); // appending file

                let xlsxVis=false, allfileVis=false, drnotesVis=false;

                if(e.target.id=="xlsxSubmit"){
                    formData.append('uploadtype', 'account_creation'); // appending file
                    xlsxVis=true;
                }else if(e.target.id=="allSubmit"){
                    formData.append('uploadtype', 'patient_summary'); // appending file
                    allfileVis=true;
                }else if(e.target.id=="doctornotesSubmit"){
                    formData.append('uploadtype', 'doctor_notes'); // appending file
                    drnotesVis=true;
                }

                uploadFile(formData).then((response) => {
                    setLoading(false);
                    if(typeof(response)!=='undefined'){
                        let clas = (response.data.status == "1") ? 'success' : 'danger';
                        setFile('');
                        onShowAlert(response.data.data.message,xlsxVis,allfileVis,drnotesVis,clas);    
                        
                    }
                    document.getElementById("xlsxFile").value = "";
                    document.getElementById("allFile").value = "";
                    document.getElementById("doctornotes").value = "";
                }
            );
        }else{
            alert('Please select file');
        }
        
        
    }
    return (
        <>
            <section className='projects-section'>
                 
                <div className='row'>
                    <h1 className='title mb-4'>Upload Patient Account Creation Data</h1>
                    <div className="file-upload">
                        <div className="row ">

                            <div className="col-md-5 col-xl-4">
                                <input type="file" id="xlsxFile" className="btn-upload" accept=".xls, .xlsx, application/excel,application/vnd.msexcel, application/vnd. ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" required="required" onChange={handleChange} />

                                <span>Allowed file type :- .xlsx</span><br></br>
                                <span>File size :- 2 MB</span>
                                {alertInfo.xlsxErr ? 
                                    <div className={"text-"+ alertInfo.cls +" form-floating mb-3"} role="alert">
                                        {alertInfo.msg}
                                    </div> : null}
                            </div>

                            <div className="col-md-7 col-xl-6">
                                <button onClick={uploadFile_Html} className="btn btn-primary btn-login" id="xlsxSubmit">
                                    Upload Patient Account Creation Data
                                </button>
                            </div>
                            <div className="col-md-12"><a href="https://appcdn.goqii.com/storeimg/9311_1677565089.xlsx" target="_blank"><span>Download Sample</span></a></div>
                        </div>
                        <hr className='line' />
                        
                    </div>

                </div>


                <div className='row'>
                    <h1 className='title mb-4'>Upload Patient Health Data</h1>
                    <div className="file-upload">
                        <div className="row ">

                            <div className="col-md-5 col-xl-4">
                                <input type="file" id="allFile" className="btn-upload" accept="application/pdf,.zip,.7zip" required="required" onChange={handleChange} />

                                <span>Allowed file type :- .pdf,.zip</span><br></br>
                                <span>File size :- 2 MB</span>
                                {alertInfo.allfileErr ? 
                                    <div className={"text-"+ alertInfo.cls +" form-floating mb-3"} role="alert">
                                        {alertInfo.msg}
                                    </div> : null}
                            </div>

                            <div className="col-md-7 col-xl-6">
                                <button onClick={uploadFile_Html} className="btn btn-primary btn-login" id="allSubmit">
                                Upload Patient Medical Summary
                                </button>
                            </div>
                        </div>
                        <hr className='line' />
                        
                    </div>

                </div>

                
                <div className='row'>
                    <h1 className='title mb-4'>Upload Doctor Notes</h1>
                    <div className="file-upload">
                        <div className="row ">

                            <div className="col-md-5 col-xl-4">
                                <input type="file" id="doctornotes" className="btn-upload" accept="application/pdf,.zip,.7zip" required="required" onChange={handleChange} />

                                <span>Allowed file type :- .pdf,.zip</span><br></br>
                                <span>File size :- 2 MB</span>
                                {alertInfo.drnotesErr ? 
                                    <div className={"text-"+ alertInfo.cls +" form-floating mb-3"} role="alert">
                                        {alertInfo.msg}
                                    </div> : null}
                            </div>

                            <div className="col-md-7 col-xl-6">
                                <button onClick={uploadFile_Html} className="btn btn-primary btn-login" id="doctornotesSubmit">
                                Doctor Notes
                                </button>
                            </div>
                        </div>
                        <hr className='line' />
                        
                    </div>

                </div>
                <History /> 
            </section>
            
            { loading ? <CustomLoader /> : null }
        </>
    );
}
export default FileUpload;